import { compose, map, omit } from 'ramda'

export const cleanRequest = map(compose(omit(['place', 'checklist', 'company'])))
